<template>
  <section class="content-wrapper">
    <h1 class="minorTitle">{{detailTitle}}</h1>
    <div v-for="(item, index) in topicItems" class="content-item" :key="index" @click="toDetail(index)">
      <img v-if="index<6" class="item-poster" :src="item.vertical_cover_url" :alt="item.name" @error="imgError">
      <img v-else class="item-poster" src="" v-lazy="item.vertical_cover_url" :alt="item.name" @error="imgError">
      <div class="item-words">
        <p class="item-movieName">{{item.name}}</p>
        <grade class="item-percent" :percent="item.percent"></grade>
        <div class="item-content" style="-webkit-box-orient: vertical;">{{item.description}}</div>
        <a class="item-link-detail" :href="item.link">快去看看</a>
      </div>
    </div>
  </section>
</template>

<script>
  import grade from '~/components/movie/grade'
  import envObj from '~/assets/movie/js/env'
  import {page} from '~/assets/movie/js/setMeta'
  import {request} from '~/components/api/movie/axios'

  let baseUrl = envObj.baseUrl
  let movieUrl = envObj.movieUrl

  export default {
    components:{
      grade
    },
  data(){
    return{
      page: 1,
      size: 30,
      contentHeight: 0,
      signItem: null,
      flag: true,
      loadingJpg: require('@/static/movie/loading.jpg')
    }
  },
  async asyncData ({ app, params, route, redirect}) {
    let topic = params.topic
    let detailTitle = ''
    let param = {
      page: 1,
      size: 30
    }
    if(topic === 'reying'){
      detailTitle = '影院热映'
      param.order = ['reying']
    }else if(topic === 'remen'){
      detailTitle = '热门电影'
      param.order = ['remen']
    }else{
      detailTitle = page[topic]
      param.categories = [detailTitle]
      detailTitle = detailTitle + '电影'
    }
    let data = await request({ url: `${baseUrl}/video2/filter`, method: 'post', data: param, cache: true })
      .catch( e =>{ redirect(302, '/movie/error', { 'errorfrom': route.fullPath }) })

   // let data = await app.$axios.post(`${baseUrl}/video2/filter`, param)
   //    .catch( e =>{ redirect(302, '/movie/error', { 'errorfrom': route.fullPath }) })
    if(data.code === 0){
      data.data.forEach( item => {
        item.link = `${movieUrl}/movies/${item.id}?entrypage=xl_movie_mobile_category&entry=xl_mobile_movie_category_movie_card`
        item.percent = Math.round(item.movie_score.popcorn_index*100)
        item.vertical_cover_url = item.vertical_cover_url+ '?imageView2/1/w/297/h/372'
      })
      return {
        topicItems: data.data,
        detailTitle
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    this.signItem= document.getElementsByClassName('content-item')[25]
  },
  methods:{
    imgError (event) {
      event.target.src = this.loadingJpg
    },
    toDetail(index){
      let a = document.getElementsByClassName('item-link-detail')[index]
      a.click()
    },
    handleScroll(){
      let _this = this
      if(_this.signItem){
        let viewHeight = window.innerHeight || document.documentElement.clientHeight
        let height = _this.signItem.getBoundingClientRect().bottom

        if(viewHeight >= height){
          _this.getData()
        }
      }
    },
    // 数据懒加载
    getData(){
      let _this = this
      if(_this.flag){
        let params = {}
        _this.flag = false
        _this.page = _this.page + 1

        if(_this.detailTitle === '影院热映'){
          params = {page: _this.page, size: _this.size, order: ['reying']}
        }else if(_this.detailTitle === '热门电影'){
          params = {page: _this.page, size: _this.size, order: ['reying']}
        }else{
          let keyWords = _this.detailTitle
          keyWords = keyWords.replace('电影', '')
          params = {page: _this.page, size: _this.size, categories: [keyWords]}
        }

        // _this.$axios.post(`${baseUrl}/video2/filter`, params)
        request({ url: `${baseUrl}/video2/filter`, method: 'post', data: params, cache: true })
          .then(res => {
            if(res.data.length !== 0){
              res.data.forEach(item => {
                item.link = `${movieUrl}/movies/${item.id}?entrypage=xl_movie_mobile_category&entry=xl_mobile_movie_category_movie_card`
                item.percent = Math.round(item.movie_score.popcorn_index*100)
                item.vertical_cover_url = item.vertical_cover_url+ '?imageView2/1/w/297/h/372'
              })
              _this.topicItems.push(...res.data)
              let beginIndex = _this.topicItems.length - 4
              _this.$nextTick(()=>{
                _this.signItem = document.getElementsByClassName('content-item')[beginIndex - 1]
                _this.flag = true
              })
            }
          })
          .catch(res => {

          })
      }
    }
  }
}
</script>

<style lang="scss">
  .content-wrapper{
    width: 990px;
    margin: 180px auto 0;
    .minorTitle{
      font-size: 45px;
      color: #262A2F;
      font-weight: bold;
      margin: 36px 0;
    }
    .content-item{
      display: table;
      position: relative;
      margin-bottom: 60px;
      .item-poster{
        display: table-cell;
        vertical-align: top;
        width: 279px;
        height: 372px;
        border-radius: 20px;
        margin-right: 30px;
        background-color: #f0f1f2;
      }
      .item-words{
        display: table-cell;
        vertical-align: top;
        padding-left: 10px;
        .item-movieName{
          font-size: 48px;
          font-weight: bolder;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 26px;
        }
        .item-percent{
          font-size: 36px;
          color: #70767D;
          margin-bottom: 30px;
        }
        .item-content{
          font-size: 42px;
          color: #979AA0;
          width: 100%;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .item-link-detail{
          position: absolute;
          bottom: 0;
          width: 240px;
          line-height: 36px;
          padding: 18px 0;
          text-align: center;
          border-radius: 120px;
          font-size: 36px;
          background-color: #1aa3ff;
          color: #fff;
        }
      }
    }
  }
</style>
